import queryString from "query-string";
import { AUTH_QUERY_PARAMS } from "../../../../api/shopify/useSaveShopifyIntegrationDataMutation";

export const getAuthQueryParams = () => {
  const params = queryString.parse(window.location.search);

  const code = params[AUTH_QUERY_PARAMS.code];
  const hmac = params[AUTH_QUERY_PARAMS.hmac];
  const host = params[AUTH_QUERY_PARAMS.host];
  const shop = params[AUTH_QUERY_PARAMS.shop];
  const state = params[AUTH_QUERY_PARAMS.state];
  const timestamp = params[AUTH_QUERY_PARAMS.timestamp];

  return [code, hmac, host, shop, state, timestamp].every(Boolean)
    ? {
        code,
        hmac,
        host,
        shop,
        state,
        timestamp,
      }
    : null;
};
